module.exports = "/images/shipping_policy.svg?ba49d2950aa6b97b20078912f60a50e7";